import type { CoursesQuery } from '@innovamat/glow-api-client';
import { useCoursesQuery, type Classroom } from '@innovamat/glow-api-client';
import type { QueryClient } from '@tanstack/react-query';

type UpdateProps = {
  queryClient: QueryClient;
  orgId: string;
  region: string;
  updatedClassroom: Classroom;
};

type ClassroomsQueryData = { classrooms: Classroom[] };

function updateClassroomInCache({
  queryClient,
  orgId,
  region,
  updatedClassroom,
}: UpdateProps): void {
  const mineVariables = ['Classrooms', { mine: true, orgId }];
  const notMineVariables = ['Classrooms', { mine: false, orgId }];

  const courses = queryClient.getQueryData<CoursesQuery>(
    useCoursesQuery.getKey({ regionCode: region })
  );

  const updatedClassroomCourse = courses?.courses.find(
    (course) => course.id === updatedClassroom.courseId
  );

  const finalUpdatedClassroom = {
    ...updatedClassroom,
    courseName: updatedClassroomCourse?.name ?? updatedClassroom.courseName,
    courseOrder: updatedClassroomCourse?.order ?? updatedClassroom.courseOrder,
  };

  const mineCurrentClassrooms =
    queryClient.getQueryData<ClassroomsQueryData>(mineVariables)?.classrooms;

  const notMineCurrentClassrooms =
    queryClient.getQueryData<ClassroomsQueryData>(notMineVariables)?.classrooms;

  if (mineCurrentClassrooms) {
    const updatedClassrooms = mineCurrentClassrooms.map((classroom) =>
      classroom.id === finalUpdatedClassroom.id
        ? finalUpdatedClassroom
        : classroom
    );

    queryClient.setQueryData(mineVariables, {
      classrooms: updatedClassrooms,
    });
  }

  if (notMineCurrentClassrooms) {
    const updatedClassrooms = notMineCurrentClassrooms.map((classroom) =>
      classroom.id === finalUpdatedClassroom.id
        ? finalUpdatedClassroom
        : classroom
    );

    queryClient.setQueryData(notMineVariables, {
      classrooms: updatedClassrooms,
    });
  }
}

export { updateClassroomInCache };
